import { createTheme, Theme } from '@mui/material/styles';

// Monsoon Aquatics brand colours (monsoonaquatics.com.au header / accent)
export const brand = {
  navy: '#152740',
  coral: '#FF4653',
  navyLight: '#EEF2F8',
  navyMid: '#3A5478',
};

// Coloured top edge for page cards: coral for input / action cards, navy for results.
export const accent = {
  coral: { borderTop: `4px solid ${brand.coral}` },
  navy: { borderTop: `4px solid ${brand.navy}` },
};

const theme: Theme = createTheme({
  palette: {
    primary: {
      main: brand.navy,
      light: '#3A5478',
      dark: '#0C1726',
      contrastText: '#ffffff',
    },
    secondary: {
      main: brand.coral,
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h4: { color: brand.navy, fontWeight: 700 },
    h5: { color: brand.navy, fontWeight: 700 },
    h6: { color: brand.navy, fontWeight: 600 },
  },
  components: {
    // Navy header row on every table (stickyHeader tables use their own slot)
    MuiTableCell: {
      styleOverrides: {
        head: { backgroundColor: brand.navy, color: '#fff', fontWeight: 600 },
        stickyHeader: { backgroundColor: brand.navy, color: '#fff' },
      },
    },
  },
});

export default theme;
